import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {
  saveWizardList, getWizardList, setWizardPopupItem, setWizardPopupOpened, setWizardCloneLogic
} from "../../wizardActions";
import WizardPopupContext, {useCustomContext} from "../WizardPopupContext";
import {defaultWizardItem} from "../../WizardItem/wizardItemInterface";
import {cloneWizards} from "./wizardClonePopupAction";

let abortablePromise = null;

const WizardClonePopupSaveButton = (props) => {

  const {wizardList, saveWizardList, getWizardList, cloneWizards, wizardCloneIsVisible, wizardCloneIsFinished,
    setWizardCloneLogic, setWizardPopupOpened, setWizardPopupItem} = props;

  const {wizardPopupState} = useCustomContext(WizardPopupContext);
  const {selectedFabricators, mode} = wizardPopupState;
  let selectedWizards = wizardList.filter(wizardItem => wizardItem.selected);

  const disabled = !wizardCloneIsVisible && (!selectedFabricators.length || !selectedWizards.length);

  const saveButton = async () => {
    if (wizardCloneIsVisible && wizardCloneIsFinished) {
      setWizardCloneLogic({visible: false});
      setWizardPopupOpened(false);
      setWizardPopupItem(defaultWizardItem)
      return
    } else if (wizardCloneIsVisible) {
      abortablePromise.abort();
      setWizardCloneLogic({visible: false})
      return
    }
    if (disabled) {
      return false
    }
    cloneWizards(selectedWizards, selectedFabricators, mode, saveWizardList, getWizardList, abortablePromise);
  };

  return (
    <button className={"ui-button5 ui-button5--wide text-uppercase "
      + (disabled ? " ui-button--disabled" : "") + (wizardCloneIsVisible && !wizardCloneIsFinished ? " ui-button5--blue" : " ui-button5--green")}
            onClick={saveButton}
            disabled={disabled}>
      <FormattedMessage id={wizardCloneIsVisible
        ? wizardCloneIsFinished ? "messageBox.buttons.close"  : "messageBox.buttons.cancel"
        : "messageBox.buttons.save"}/>
    </button>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardVisualizer, wizardCloneLogic} = store.wizardState;
  const {visible, finished} = wizardCloneLogic;
  return {
    wizardList: wizardList.filter(wizardItem => wizardItem.visualizer === wizardVisualizer),
    wizardVisualizer,
    wizardCloneIsVisible: visible,
    wizardCloneIsFinished: finished,
  };
};

const mapDispatchToProps = {
  getWizardList,
  saveWizardList,
  cloneWizards,
  setWizardCloneLogic,
  setWizardPopupItem,
  setWizardPopupOpened
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(WizardClonePopupSaveButton)
)
